import {AppSettings} from '#/indie-settings/settings'

export function bskyTitle(page: string, unreadCountLabel?: string) {
  const unreadPrefix = unreadCountLabel ? `(${unreadCountLabel}) ` : ''
  return `${unreadPrefix}${page} — ${AppSettings.APP_NAME}`
}
